import ActionButton from 'components/ActionButton';
import SearchBar from 'components/Autosuggest/Autosuggest';
import OrderStatusDropdown from 'components/OrderStatusDropdown';
import React, { useEffect, useState } from 'react';
// import { searchItems } from 'services';
import { searchUserByName } from 'services/api/common';
import styles from './index.module.scss';
import qs from 'query-string';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import { DATE_FORMATS, USER_ROLES, formatDate } from 'utils';
import AccountsDropdown from 'components/AccountsDropdown';
import DropDown from 'components/FormFields/dropdown';
import SalesChannelDropwdown from 'components/SalesChannelsDropdown';
import UsersDropdown from 'components/UsersDropdown';

const WAITING_FOR_PAYMENT_OPTIONS = [{ value: '', name: 'ALL' }, { value: 'true', name: 'True' }, { value: 'false', name: 'False' }];

const Filter = props => {
  const [orderId, setOrderId] = useState<string>('');
  const [user, setUser] = useState<Record<string, any>>({});
  const [isExternalOrder, setIsExternalOrder] = useState<boolean>(false);
  const [status, setStatus] = useState<string>('');
  const [salesChannelId, setSalesChannelId] = useState<string>('');
  const [salesPersonId, setSalesPersonId] = useState<string>('');
  const [startDate, setStartDate] = useState<string | null>(moment().subtract(4, 'days').toISOString());
  const [endDate, setEndDate] = useState<string | null>(moment().toISOString());
  const [isHomeBoxOrder, setIsHomeBoxOrder] = useState<boolean>(false);
  const [accountId, setAccountId] = useState<string>('');
  const [waitingForPayment, setWaitingForPayment] = useState<string>('');
  const [email, setEmail] = useState<string>('');

  useEffect(() => {
    const {
      orderId,
      status,
      isHomeBoxOrder,
      isExternalOrder,
      startDate,
      endDate,
      accountId,
      email,
      waitingForPayment,
      salesChannelId,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    setOrderId(orderId?.toString() || '');
    setStatus(status?.toString() || '');
    if (startDate) {
      setStartDate(startDate.toString());
    }
    if (endDate) {
      setEndDate(endDate.toString());
    }
    setIsExternalOrder(!!isExternalOrder);
    setWaitingForPayment(waitingForPayment?.toString() || '');
    setIsHomeBoxOrder(!!isHomeBoxOrder);
    setAccountId(accountId?.toString() || '');
    setEmail(email?.toString() || '');
    setSalesChannelId(salesChannelId?.toString() || '');
  }, []);


  const resetFilter = () => {
    setUser({});
    setStatus('');
    setOrderId('');
    setIsExternalOrder(false);
    setStartDate(null);
    setEndDate(null);
    setIsHomeBoxOrder(false);
    setAccountId('');
    setEmail('');
    setWaitingForPayment('');

    const filterData = {
      orderId: '',
      status: '',
      userId: '',
      startDate: '',
      endDate: '',
      accountId: '',
      email: '',
      waitingForPayment: '',
    };
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    const filterData = {
      orderId,
      status,
      isExternalOrder,
      userId: user.id,
      startDate,
      endDate,
      isHomeBoxOrder,
      accountId,
      email,
      waitingForPayment: waitingForPayment ? JSON.parse(waitingForPayment) : '',
      salesChannelId,
      salesPersonId,
    };
    props.onSubmit(filterData);
  };

  const handleUserSelect = (suggestion: Record<string, any>) => {
    const user: Record<string, any> = {};
    user.id = suggestion.objectId;
    user.name = suggestion.full_name;
    setUser(user);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={`row`}>
        <div className={`col-md-6 mb-4 mb-4 col-lg-3`}>
          <div className={styles['label']}>Order ID</div>
          <input
            className={'form-control'}
            value={orderId}
            onChange={e => setOrderId(e.target.value)}
          />
        </div>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['label']}>User</div>
          <div className={styles['autosuggest-input']}>
            <SearchBar
              isUser={true}
              className={'form-control'}
              value={user.name || ''}
              setValue={value => setUser({ ...user, name: value })}
              searchAPI={searchUserByName}
              searchAPIParamKey={'searchTerm'}
              onSuggestionClicked={handleUserSelect}
            />
          </div>
        </div>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['label']}>User Email</div>
          <input
            className={'form-control'}
            value={email}
            onChange={e => setEmail(e.target.value)}
          />
        </div>
        {/* <div className={styles['autosuggest-group']}>
        <div className={styles['label']}>Inventory Item</div>
        <div className={styles['autosuggest-input']}>
          <SearchBar
            value={item.name || ''}
            setValue={value => setItem({ ...item, name: value })}
            searchAPI={searchItems}
            searchAPIParamKey={'term'}
            onSuggestionClicked={handleInventorySelect}
          />
        </div>
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Inventory Item ID</div>
        <input
          className={'form-control'}
          value={itemId}
          onChange={e => setItemId(e.target.value)}
        />
      </div> */}
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['label']}>Start Date</div>
          <div className={styles['date-picker']}>
            <DatePicker
              wrapperClassName="w-100"
              className={'form-control'}
              selected={startDate ? moment(startDate).toDate() : null}
              onChange={(e: any) => setStartDate(formatDate(e, DATE_FORMATS.YYYY_MM_DD))}
            />
          </div>
        </div>
      </div>
      <div className={`row`}>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>End Date</div>
            <div className={styles['date-picker']}>
              <DatePicker
                wrapperClassName="w-100"
                className={'form-control'}
                selected={endDate ? moment(endDate).toDate() : null}
                onChange={(e: any) => setEndDate(formatDate(moment(e), DATE_FORMATS.YYYY_MM_DD))}
              />
            </div>
          </div>
        </div>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Status</div>
            <OrderStatusDropdown
              value={status}
              onSelect={setStatus}
            />
          </div>
        </div>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Account ID</div>
            <AccountsDropdown
              value={accountId}
              onChange={setAccountId}
            />
          </div>
        </div>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['input-group']}>
            <DropDown title="Waiting For Payment" value={waitingForPayment} onChange={setWaitingForPayment} options={WAITING_FOR_PAYMENT_OPTIONS} />
          </div>
        </div>
      </div>
      <div className={`row`}>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Sales Channel</div>
            <SalesChannelDropwdown 
              title="Sales Channel" 
              value={salesChannelId} 
              onChange={setSalesChannelId} 
            />
          </div>
        </div>
        <div className={`col-md-6 mb-4 col-lg-3`}>
          <div className={styles['input-group']}>
            <div className={styles['label']}>Sales Person</div>
            <UsersDropdown value={salesPersonId} onChange={setSalesPersonId} title="Sales Person" role={USER_ROLES.SALES_PERSON}  />
          </div>
        </div>
      </div>
      <div className={`d-flex align-items-center flex-column flex-md-row justify-content-between`}>
        <div className={`d-flex w-100`}>
          <div className={`${styles['checkbox-group']}`}>
            <input
              type={'checkbox'}
              checked={isExternalOrder}
              onChange={e => setIsExternalOrder(e.target.checked)}
            />
            <div className={styles['checkbox-label']}>External</div>
          </div>
          <div className={styles['checkbox-group']}>
            <input
              type={'checkbox'}
              className={'form-control'}
              checked={isHomeBoxOrder}
              onChange={e => setIsHomeBoxOrder(e.target.checked)}
            />
            <div className={styles['checkbox-label']}>HomeBox</div>
          </div>
        </div>
        <div className={`d-flex w-100 mt-3 mt-md-0 justify-content-start justify-content-md-end`}>
          <div className={styles['buttons-container']}>
            <ActionButton
              text={'Reset'}
              active={true}
              isLoading={false}
              onClick={resetFilter}
            />
            <ActionButton
              text={'Submit'}
              active={true}
              isSubmit={true}
              isLoading={false}
              onClick={handleSubmit}
            />
          </div>
        </div>
      </div>
    </form>
  );
};

export default Filter;